module.exports = __webpack_public_path__ + "img/bank.26068718.png";